import { signatureStyle as signature } from 'now-frontend-shared/styles/signature-styles';
import styles from '../../../../now-frontend-shared/styles/document-view-styles';

export default {
  buttonContainer: styles.buttonContainerWithBack,
  button: styles.button,
  signature,
  downloadContainer: styles.downloadContainer,
  download: styles.download,
  backButton: styles.backButton,
};
